angular.module('picmonic-common').factory('CountryStateConfig', function () {
  return {
    countries: [
      {
        id: 'BD',
        name: 'Bangladesh',
        priority: 0,
      },
      {
        id: 'BE',
        name: 'Belgium',
        priority: 0,
      },
      {
        id: 'BF',
        name: 'Burkina Faso',
        priority: 0,
      },
      {
        id: 'BG',
        name: 'Bulgaria',
        priority: 0,
      },
      {
        id: 'BA',
        name: 'Bosnia and Herzegovina',
        priority: 0,
      },
      {
        id: 'BB',
        name: 'Barbados',
        priority: 0,
      },
      {
        id: 'WF',
        name: 'Wallis and Futuna',
        priority: 0,
      },
      {
        id: 'BL',
        name: 'Saint Bartelemey',
        priority: 0,
      },
      {
        id: 'BM',
        name: 'Bermuda',
        priority: 0,
      },
      {
        id: 'BN',
        name: 'Brunei Darussalam',
        priority: 0,
      },
      {
        id: 'BO',
        name: 'Bolivia',
        priority: 0,
      },
      {
        id: 'BH',
        name: 'Bahrain',
        priority: 0,
      },
      {
        id: 'BI',
        name: 'Burundi',
        priority: 0,
      },
      {
        id: 'BJ',
        name: 'Benin',
        priority: 0,
      },
      {
        id: 'BT',
        name: 'Bhutan',
        priority: 0,
      },
      {
        id: 'JM',
        name: 'Jamaica',
        priority: 0,
      },
      {
        id: 'BV',
        name: 'Bouvet Island',
        priority: 0,
      },
      {
        id: 'BW',
        name: 'Botswana',
        priority: 0,
      },
      {
        id: 'WS',
        name: 'Samoa',
        priority: 0,
      },
      {
        id: 'BR',
        name: 'Brazil',
        priority: 0,
      },
      {
        id: 'BS',
        name: 'Bahamas',
        priority: 0,
      },
      {
        id: 'JE',
        name: 'Jersey',
        priority: 0,
      },
      {
        id: 'BY',
        name: 'Belarus',
        priority: 0,
      },
      {
        id: 'O1',
        name: 'Other Country',
        priority: 0,
      },
      {
        id: 'LV',
        name: 'Latvia',
        priority: 0,
      },
      {
        id: 'RW',
        name: 'Rwanda',
        priority: 0,
      },
      {
        id: 'RS',
        name: 'Serbia',
        priority: 0,
      },
      {
        id: 'TL',
        name: 'Timor-Leste',
        priority: 0,
      },
      {
        id: 'RE',
        name: 'Reunion',
        priority: 0,
      },
      {
        id: 'LU',
        name: 'Luxembourg',
        priority: 0,
      },
      {
        id: 'TJ',
        name: 'Tajikistan',
        priority: 0,
      },
      {
        id: 'RO',
        name: 'Romania',
        priority: 0,
      },
      {
        id: 'PG',
        name: 'Papua New Guinea',
        priority: 0,
      },
      {
        id: 'GW',
        name: 'Guinea-Bissau',
        priority: 0,
      },
      {
        id: 'GU',
        name: 'Guam',
        priority: 0,
      },
      {
        id: 'GT',
        name: 'Guatemala',
        priority: 0,
      },
      {
        id: 'GS',
        name: 'South Georgia and the South Sandwich Islands',
        priority: 0,
      },
      {
        id: 'GR',
        name: 'Greece',
        priority: 0,
      },
      {
        id: 'GQ',
        name: 'Equatorial Guinea',
        priority: 0,
      },
      {
        id: 'GP',
        name: 'Guadeloupe',
        priority: 0,
      },
      {
        id: 'JP',
        name: 'Japan',
        priority: 0,
      },
      {
        id: 'GY',
        name: 'Guyana',
        priority: 0,
      },
      {
        id: 'GG',
        name: 'Guernsey',
        priority: 0,
      },
      {
        id: 'GF',
        name: 'French Guiana',
        priority: 0,
      },
      {
        id: 'GE',
        name: 'Georgia',
        priority: 0,
      },
      {
        id: 'GD',
        name: 'Grenada',
        priority: 0,
      },
      {
        id: 'GB',
        name: 'United Kingdom',
        priority: 0,
      },
      {
        id: 'GA',
        name: 'Gabon',
        priority: 0,
      },
      {
        id: 'SV',
        name: 'El Salvador',
        priority: 0,
      },
      {
        id: 'GN',
        name: 'Guinea',
        priority: 0,
      },
      {
        id: 'GM',
        name: 'Gambia',
        priority: 0,
      },
      {
        id: 'GL',
        name: 'Greenland',
        priority: 0,
      },
      {
        id: 'GI',
        name: 'Gibraltar',
        priority: 0,
      },
      {
        id: 'GH',
        name: 'Ghana',
        priority: 0,
      },
      {
        id: 'OM',
        name: 'Oman',
        priority: 0,
      },
      {
        id: 'TN',
        name: 'Tunisia',
        priority: 0,
      },
      {
        id: 'JO',
        name: 'Jordan',
        priority: 0,
      },
      {
        id: 'HR',
        name: 'Croatia',
        priority: 0,
      },
      {
        id: 'HT',
        name: 'Haiti',
        priority: 0,
      },
      {
        id: 'HU',
        name: 'Hungary',
        priority: 0,
      },
      {
        id: 'HK',
        name: 'Hong Kong',
        priority: 0,
      },
      {
        id: 'HN',
        name: 'Honduras',
        priority: 0,
      },
      {
        id: 'HM',
        name: 'Heard Island and McDonald Islands',
        priority: 0,
      },
      {
        id: 'VE',
        name: 'Venezuela',
        priority: 0,
      },
      {
        id: 'PR',
        name: 'Puerto Rico',
        priority: 0,
      },
      {
        id: 'PS',
        name: 'Palestinian Territory',
        priority: 0,
      },
      {
        id: 'PW',
        name: 'Palau',
        priority: 0,
      },
      {
        id: 'PT',
        name: 'Portugal',
        priority: 0,
      },
      {
        id: 'SJ',
        name: 'Svalbard and Jan Mayen',
        priority: 0,
      },
      {
        id: 'PY',
        name: 'Paraguay',
        priority: 0,
      },
      {
        id: 'IQ',
        name: 'Iraq',
        priority: 0,
      },
      {
        id: 'PA',
        name: 'Panama',
        priority: 0,
      },
      {
        id: 'PF',
        name: 'French Polynesia',
        priority: 0,
      },
      {
        id: 'BZ',
        name: 'Belize',
        priority: 0,
      },
      {
        id: 'PE',
        name: 'Peru',
        priority: 0,
      },
      {
        id: 'PK',
        name: 'Pakistan',
        priority: 0,
      },
      {
        id: 'PH',
        name: 'Philippines',
        priority: 0,
      },
      {
        id: 'PN',
        name: 'Pitcairn',
        priority: 0,
      },
      {
        id: 'TM',
        name: 'Turkmenistan',
        priority: 0,
      },
      {
        id: 'PL',
        name: 'Poland',
        priority: 0,
      },
      {
        id: 'PM',
        name: 'Saint Pierre and Miquelon',
        priority: 0,
      },
      {
        id: 'ZM',
        name: 'Zambia',
        priority: 0,
      },
      {
        id: 'EH',
        name: 'Western Sahara',
        priority: 0,
      },
      {
        id: 'RU',
        name: 'Russian Federation',
        priority: 0,
      },
      {
        id: 'EE',
        name: 'Estonia',
        priority: 0,
      },
      {
        id: 'EG',
        name: 'Egypt',
        priority: 0,
      },
      {
        id: 'TK',
        name: 'Tokelau',
        priority: 0,
      },
      {
        id: 'ZA',
        name: 'South Africa',
        priority: 0,
      },
      {
        id: 'EC',
        name: 'Ecuador',
        priority: 0,
      },
      {
        id: 'IT',
        name: 'Italy',
        priority: 0,
      },
      {
        id: 'VN',
        name: 'Vietnam',
        priority: 0,
      },
      {
        id: 'SB',
        name: 'Solomon Islands',
        priority: 0,
      },
      {
        id: 'EU',
        name: 'Europe',
        priority: 0,
      },
      {
        id: 'ET',
        name: 'Ethiopia',
        priority: 0,
      },
      {
        id: 'SO',
        name: 'Somalia',
        priority: 0,
      },
      {
        id: 'ZW',
        name: 'Zimbabwe',
        priority: 0,
      },
      {
        id: 'SA',
        name: 'Saudi Arabia',
        priority: 0,
      },
      {
        id: 'ES',
        name: 'Spain',
        priority: 0,
      },
      {
        id: 'ER',
        name: 'Eritrea',
        priority: 0,
      },
      {
        id: 'ME',
        name: 'Montenegro',
        priority: 0,
      },
      {
        id: 'MD',
        name: 'Moldova, Republic of',
        priority: 0,
      },
      {
        id: 'MG',
        name: 'Madagascar',
        priority: 0,
      },
      {
        id: 'MF',
        name: 'Saint Martin',
        priority: 0,
      },
      {
        id: 'MA',
        name: 'Morocco',
        priority: 0,
      },
      {
        id: 'MC',
        name: 'Monaco',
        priority: 0,
      },
      {
        id: 'UZ',
        name: 'Uzbekistan',
        priority: 0,
      },
      {
        id: 'MM',
        name: 'Myanmar',
        priority: 0,
      },
      {
        id: 'ML',
        name: 'Mali',
        priority: 0,
      },
      {
        id: 'MO',
        name: 'Macao',
        priority: 0,
      },
      {
        id: 'MN',
        name: 'Mongolia',
        priority: 0,
      },
      {
        id: 'MH',
        name: 'Marshall Islands',
        priority: 0,
      },
      {
        id: 'MK',
        name: 'Macedonia',
        priority: 0,
      },
      {
        id: 'MU',
        name: 'Mauritius',
        priority: 0,
      },
      {
        id: 'MT',
        name: 'Malta',
        priority: 0,
      },
      {
        id: 'MW',
        name: 'Malawi',
        priority: 0,
      },
      {
        id: 'MV',
        name: 'Maldives',
        priority: 0,
      },
      {
        id: 'MQ',
        name: 'Martinique',
        priority: 0,
      },
      {
        id: 'MP',
        name: 'Northern Mariana Islands',
        priority: 0,
      },
      {
        id: 'MS',
        name: 'Montserrat',
        priority: 0,
      },
      {
        id: 'MR',
        name: 'Mauritania',
        priority: 0,
      },
      {
        id: 'IM',
        name: 'Isle of Man',
        priority: 0,
      },
      {
        id: 'UG',
        name: 'Uganda',
        priority: 0,
      },
      {
        id: 'TZ',
        name: 'Tanzania, United Republic of',
        priority: 0,
      },
      {
        id: 'MY',
        name: 'Malaysia',
        priority: 0,
      },
      {
        id: 'MX',
        name: 'Mexico',
        priority: 0,
      },
      {
        id: 'IL',
        name: 'Israel',
        priority: 0,
      },
      {
        id: 'FR',
        name: 'France',
        priority: 0,
      },
      {
        id: 'IO',
        name: 'British Indian Ocean Territory',
        priority: 0,
      },
      {
        id: 'FX',
        name: 'France, Metropolitan',
        priority: 0,
      },
      {
        id: 'SH',
        name: 'Saint Helena',
        priority: 0,
      },
      {
        id: 'FI',
        name: 'Finland',
        priority: 0,
      },
      {
        id: 'FJ',
        name: 'Fiji',
        priority: 0,
      },
      {
        id: 'FK',
        name: 'Falkland Islands (Malvinas)',
        priority: 0,
      },
      {
        id: 'FM',
        name: 'Micronesia, Federated States of',
        priority: 0,
      },
      {
        id: 'FO',
        name: 'Faroe Islands',
        priority: 0,
      },
      {
        id: 'NI',
        name: 'Nicaragua',
        priority: 0,
      },
      {
        id: 'NL',
        name: 'Netherlands',
        priority: 0,
      },
      {
        id: 'NO',
        name: 'Norway',
        priority: 0,
      },
      {
        id: 'NA',
        name: 'Namibia',
        priority: 0,
      },
      {
        id: 'VU',
        name: 'Vanuatu',
        priority: 0,
      },
      {
        id: 'NC',
        name: 'New Caledonia',
        priority: 0,
      },
      {
        id: 'NE',
        name: 'Niger',
        priority: 0,
      },
      {
        id: 'NF',
        name: 'Norfolk Island',
        priority: 0,
      },
      {
        id: 'NG',
        name: 'Nigeria',
        priority: 0,
      },
      {
        id: 'NZ',
        name: 'New Zealand',
        priority: 0,
      },
      {
        id: 'NP',
        name: 'Nepal',
        priority: 0,
      },
      {
        id: 'NR',
        name: 'Nauru',
        priority: 0,
      },
      {
        id: 'NU',
        name: 'Niue',
        priority: 0,
      },
      {
        id: 'CK',
        name: 'Cook Islands',
        priority: 0,
      },
      {
        id: 'CI',
        name: "Cote d'Ivoire",
        priority: 0,
      },
      {
        id: 'CH',
        name: 'Switzerland',
        priority: 0,
      },
      {
        id: 'CO',
        name: 'Colombia',
        priority: 0,
      },
      {
        id: 'CN',
        name: 'China',
        priority: 0,
      },
      {
        id: 'CM',
        name: 'Cameroon',
        priority: 0,
      },
      {
        id: 'CL',
        name: 'Chile',
        priority: 0,
      },
      {
        id: 'CC',
        name: 'Cocos (Keeling) Islands',
        priority: 0,
      },
      {
        id: 'CA',
        name: 'Canada',
        priority: 0,
      },
      {
        id: 'CG',
        name: 'Congo',
        priority: 0,
      },
      {
        id: 'CF',
        name: 'Central African Republic',
        priority: 0,
      },
      {
        id: 'CD',
        name: 'Congo, The Democratic Republic of the',
        priority: 0,
      },
      {
        id: 'CZ',
        name: 'Czech Republic',
        priority: 0,
      },
      {
        id: 'CY',
        name: 'Cyprus',
        priority: 0,
      },
      {
        id: 'CX',
        name: 'Christmas Island',
        priority: 0,
      },
      {
        id: 'CR',
        name: 'Costa Rica',
        priority: 0,
      },
      {
        id: 'CV',
        name: 'Cape Verde',
        priority: 0,
      },
      {
        id: 'CU',
        name: 'Cuba',
        priority: 0,
      },
      {
        id: 'SZ',
        name: 'Swaziland',
        priority: 0,
      },
      {
        id: 'SY',
        name: 'Syrian Arab Republic',
        priority: 0,
      },
      {
        id: 'KG',
        name: 'Kyrgyzstan',
        priority: 0,
      },
      {
        id: 'KE',
        name: 'Kenya',
        priority: 0,
      },
      {
        id: 'SR',
        name: 'Suriname',
        priority: 0,
      },
      {
        id: 'KI',
        name: 'Kiribati',
        priority: 0,
      },
      {
        id: 'KH',
        name: 'Cambodia',
        priority: 0,
      },
      {
        id: 'KN',
        name: 'Saint Kitts and Nevis',
        priority: 0,
      },
      {
        id: 'KM',
        name: 'Comoros',
        priority: 0,
      },
      {
        id: 'ST',
        name: 'Sao Tome and Principe',
        priority: 0,
      },
      {
        id: 'SK',
        name: 'Slovakia',
        priority: 0,
      },
      {
        id: 'KR',
        name: 'Korea, Republic of',
        priority: 0,
      },
      {
        id: 'SI',
        name: 'Slovenia',
        priority: 0,
      },
      {
        id: 'KP',
        name: "Korea, Democratic People's Republic of",
        priority: 0,
      },
      {
        id: 'KW',
        name: 'Kuwait',
        priority: 0,
      },
      {
        id: 'SN',
        name: 'Senegal',
        priority: 0,
      },
      {
        id: 'SM',
        name: 'San Marino',
        priority: 0,
      },
      {
        id: 'SL',
        name: 'Sierra Leone',
        priority: 0,
      },
      {
        id: 'SC',
        name: 'Seychelles',
        priority: 0,
      },
      {
        id: 'KZ',
        name: 'Kazakhstan',
        priority: 0,
      },
      {
        id: 'KY',
        name: 'Cayman Islands',
        priority: 0,
      },
      {
        id: 'SG',
        name: 'Singapore',
        priority: 0,
      },
      {
        id: 'SE',
        name: 'Sweden',
        priority: 0,
      },
      {
        id: 'SD',
        name: 'Sudan',
        priority: 0,
      },
      {
        id: 'DO',
        name: 'Dominican Republic',
        priority: 0,
      },
      {
        id: 'DM',
        name: 'Dominica',
        priority: 0,
      },
      {
        id: 'DJ',
        name: 'Djibouti',
        priority: 0,
      },
      {
        id: 'DK',
        name: 'Denmark',
        priority: 0,
      },
      {
        id: 'VG',
        name: 'Virgin Islands, British',
        priority: 0,
      },
      {
        id: 'DE',
        name: 'Germany',
        priority: 0,
      },
      {
        id: 'YE',
        name: 'Yemen',
        priority: 0,
      },
      {
        id: 'DZ',
        name: 'Algeria',
        priority: 0,
      },
      {
        id: 'US',
        name: 'United States',
        priority: 1,
      },
      {
        id: 'UY',
        name: 'Uruguay',
        priority: 0,
      },
      {
        id: 'YT',
        name: 'Mayotte',
        priority: 0,
      },
      {
        id: 'UM',
        name: 'United States Minor Outlying Islands',
        priority: 0,
      },
      {
        id: 'LB',
        name: 'Lebanon',
        priority: 0,
      },
      {
        id: 'LC',
        name: 'Saint Lucia',
        priority: 0,
      },
      {
        id: 'LA',
        name: "Lao People's Democratic Republic",
        priority: 0,
      },
      {
        id: 'TV',
        name: 'Tuvalu',
        priority: 0,
      },
      {
        id: 'TW',
        name: 'Taiwan',
        priority: 0,
      },
      {
        id: 'TT',
        name: 'Trinidad and Tobago',
        priority: 0,
      },
      {
        id: 'TR',
        name: 'Turkey',
        priority: 0,
      },
      {
        id: 'LK',
        name: 'Sri Lanka',
        priority: 0,
      },
      {
        id: 'LI',
        name: 'Liechtenstein',
        priority: 0,
      },
      {
        id: 'A1',
        name: 'Anonymous Proxy',
        priority: 0,
      },
      {
        id: 'TO',
        name: 'Tonga',
        priority: 0,
      },
      {
        id: 'LT',
        name: 'Lithuania',
        priority: 0,
      },
      {
        id: 'A2',
        name: 'Satellite Provider',
        priority: 0,
      },
      {
        id: 'LR',
        name: 'Liberia',
        priority: 0,
      },
      {
        id: 'LS',
        name: 'Lesotho',
        priority: 0,
      },
      {
        id: 'TH',
        name: 'Thailand',
        priority: 0,
      },
      {
        id: 'TF',
        name: 'French Southern Territories',
        priority: 0,
      },
      {
        id: 'TG',
        name: 'Togo',
        priority: 0,
      },
      {
        id: 'TD',
        name: 'Chad',
        priority: 0,
      },
      {
        id: 'TC',
        name: 'Turks and Caicos Islands',
        priority: 0,
      },
      {
        id: 'LY',
        name: 'Libyan Arab Jamahiriya',
        priority: 0,
      },
      {
        id: 'VA',
        name: 'Holy See (Vatican City State)',
        priority: 0,
      },
      {
        id: 'VC',
        name: 'Saint Vincent and the Grenadines',
        priority: 0,
      },
      {
        id: 'AE',
        name: 'United Arab Emirates',
        priority: 0,
      },
      {
        id: 'AD',
        name: 'Andorra',
        priority: 0,
      },
      {
        id: 'AG',
        name: 'Antigua and Barbuda',
        priority: 0,
      },
      {
        id: 'AF',
        name: 'Afghanistan',
        priority: 0,
      },
      {
        id: 'AI',
        name: 'Anguilla',
        priority: 0,
      },
      {
        id: 'VI',
        name: 'Virgin Islands, U.S.',
        priority: 0,
      },
      {
        id: 'IS',
        name: 'Iceland',
        priority: 0,
      },
      {
        id: 'IR',
        name: 'Iran, Islamic Republic of',
        priority: 0,
      },
      {
        id: 'AM',
        name: 'Armenia',
        priority: 0,
      },
      {
        id: 'AL',
        name: 'Albania',
        priority: 0,
      },
      {
        id: 'AO',
        name: 'Angola',
        priority: 0,
      },
      {
        id: 'AN',
        name: 'Netherlands Antilles',
        priority: 0,
      },
      {
        id: 'AQ',
        name: 'Antarctica',
        priority: 0,
      },
      {
        id: 'AP',
        name: 'Asia/Pacific Region',
        priority: 0,
      },
      {
        id: 'AS',
        name: 'American Samoa',
        priority: 0,
      },
      {
        id: 'AR',
        name: 'Argentina',
        priority: 0,
      },
      {
        id: 'AU',
        name: 'Australia',
        priority: 0,
      },
      {
        id: 'AT',
        name: 'Austria',
        priority: 0,
      },
      {
        id: 'AW',
        name: 'Aruba',
        priority: 0,
      },
      {
        id: 'IN',
        name: 'India',
        priority: 0,
      },
      {
        id: 'AX',
        name: 'Aland Islands',
        priority: 0,
      },
      {
        id: 'AZ',
        name: 'Azerbaijan',
        priority: 0,
      },
      {
        id: 'IE',
        name: 'Ireland',
        priority: 0,
      },
      {
        id: 'ID',
        name: 'Indonesia',
        priority: 0,
      },
      {
        id: 'UA',
        name: 'Ukraine',
        priority: 0,
      },
      {
        id: 'QA',
        name: 'Qatar',
        priority: 0,
      },
      {
        id: 'MZ',
        name: 'Mozambique',
        priority: 0,
      },
    ],

    states: [
      {
        id: 'AL',
        name: 'Alabama',
      },
      {
        id: 'AK',
        name: 'Alaska',
      },
      {
        id: 'AZ',
        name: 'Arizona',
      },
      {
        id: 'AR',
        name: 'Arkansas',
      },
      {
        id: 'CA',
        name: 'California',
      },
      {
        id: 'CO',
        name: 'Colorado',
      },
      {
        id: 'CT',
        name: 'Connecticut',
      },
      {
        id: 'DE',
        name: 'Delaware',
      },
      {
        id: 'DC',
        name: 'District of Columbia',
      },
      {
        id: 'FL',
        name: 'Florida',
      },
      {
        id: 'GA',
        name: 'Georgia',
      },
      {
        id: 'HI',
        name: 'Hawaii',
      },
      {
        id: 'ID',
        name: 'Idaho',
      },
      {
        id: 'IL',
        name: 'Illinois',
      },
      {
        id: 'IN',
        name: 'Indiana',
      },
      {
        id: 'IA',
        name: 'Iowa',
      },
      {
        id: 'KA',
        name: 'Kansas',
      },
      {
        id: 'KY',
        name: 'Kentucky',
      },
      {
        id: 'LA',
        name: 'Louisiana',
      },
      {
        id: 'ME',
        name: 'Maine',
      },
      {
        id: 'MD',
        name: 'Maryland',
      },
      {
        id: 'MA',
        name: 'Massachusetts',
      },
      {
        id: 'MI',
        name: 'Michigan',
      },
      {
        id: 'MN',
        name: 'Minnesota',
      },
      {
        id: 'MS',
        name: 'Mississippi',
      },
      {
        id: 'MO',
        name: 'Missouri',
      },
      {
        id: 'MT',
        name: 'Montana',
      },
      {
        id: 'NE',
        name: 'Nebraska',
      },
      {
        id: 'NV',
        name: 'Nevada',
      },
      {
        id: 'NH',
        name: 'New Hampshire',
      },
      {
        id: 'NJ',
        name: 'New Jersey',
      },
      {
        id: 'NM',
        name: 'New Mexico',
      },
      {
        id: 'NY',
        name: 'New York',
      },
      {
        id: 'NC',
        name: 'North Carolina',
      },
      {
        id: 'ND',
        name: 'North Dakota',
      },
      {
        id: 'OH',
        name: 'Ohio',
      },
      {
        id: 'OK',
        name: 'Oklahoma',
      },
      {
        id: 'OR',
        name: 'Oregon',
      },
      {
        id: 'PA',
        name: 'Pennsylvania',
      },
      {
        id: 'RI',
        name: 'Rhode Island',
      },
      {
        id: 'SC',
        name: 'South Carolina',
      },
      {
        id: 'SD',
        name: 'South Dakota',
      },
      {
        id: 'TN',
        name: 'Tennessee',
      },
      {
        id: 'TX',
        name: 'Texas',
      },
      {
        id: 'UT',
        name: 'Utah',
      },
      {
        id: 'VT',
        name: 'Vermont',
      },
      {
        id: 'VA',
        name: 'Virginia',
      },
      {
        id: 'WA',
        name: 'Washington',
      },
      {
        id: 'WV',
        name: 'West Virginia',
      },
      {
        id: 'WI',
        name: 'Wisconsin',
      },
      {
        id: 'WY',
        name: 'Wyoming',
      },
    ],
  };
});
